import { useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useConfigurationStore } from '@store/configurationStore';

interface UseCloseGuardsArgs {
  isEditing: boolean;
  hasUnsavedChanges?: boolean;
  onCancelEdit?: () => void;
}

export const useCloseGuards = ({ isEditing, hasUnsavedChanges, onCancelEdit }: UseCloseGuardsArgs) => {
  const { currentStep, closePopup, channelSideModalOpen } = useConfigurationStore(
    useShallow((s) => ({
      currentStep: s.currentStep,
      closePopup: s.closePopup,
      channelSideModalOpen: s.channelSideModal.open,
    }))
  );
  const [showLeaveDialog, setShowLeaveDialog] = useState(false);
  const [showDiscardWarning, setShowDiscardWarning] = useState(false);

  const handleClose = () => {
    if (channelSideModalOpen) return;
    if (isEditing) {
      if (hasUnsavedChanges) {
        setShowDiscardWarning(true);
      } else {
        onCancelEdit?.();
      }
      return;
    }
    if (currentStep === 'equipment') {
      setShowLeaveDialog(true);
    } else {
      closePopup();
    }
  };

  const handleLeave = () => {
    closePopup();
    setShowLeaveDialog(false);
  };

  const dismissLeaveDialog = () => setShowLeaveDialog(false);

  const discardChanges = () => {
    setShowDiscardWarning(false);
    onCancelEdit?.();
  };

  const dismissDiscardWarning = () => setShowDiscardWarning(false);

  return {
    showLeaveDialog,
    showDiscardWarning,
    handleClose,
    handleLeave,
    dismissLeaveDialog,
    discardChanges,
    dismissDiscardWarning,
  };
};
